export const MFA_RESET = {
  dv1: "https://keycloak-tst.pubnonprod.aws.benefitsystems.pl/realms/sso/mybenefit-api/external/v1/users/{uuid}/mfa/reset",
  qa1: "https://stg-keycloak.benefitsystems.pl/realms/sso/mybenefit-api/external/v1/users/{uuid}/mfa/reset",
  prod: "https://login.emultisport.pl/realms/sso/mybenefit-api/external/v1/users/{uuid}/mfa/reset",
};

export const FORMER_IDP = {
  dv1: "https://keycloak-tst.pubnonprod.aws.benefitsystems.pl/realms/sso/mybenefit-api/external/v1/users/{uuid}/formerIdp",
  qa1: "https://stg-keycloak.benefitsystems.pl/realms/sso/mybenefit-api/external/v1/users/{uuid}/formerIdp",
  prod: "https://login.emultisport.pl/realms/sso/mybenefit-api/external/v1/users/{uuid}/formerIdp",
};

export const PAYROLL_DOMAIN = {
  dv1: "https://saas-api.wynagrodzenia.dev.aws.mybenefit.pl",
  qa1: "https://saas-api.wynagrodzenia.staging.aws.mybenefit.pl",
  prod: "https://saas-api.wynagrodzenia.mybenefit.pl",
};
